// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ManageEachStaffHeader_mainWrapper__yKk5R","tab":"ManageEachStaffHeader_tab__z4UPN","activeTab":"ManageEachStaffHeader_activeTab__SdQWh"};